import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';

export const Value = styled.span`
    margin-left: 1rem;
    font-size: 120%;
    line-height: 120%;
    color: rgb(0, 48, 86);
`;

export const ValueField = ({
    intl,
    value,
    onChange,
    unit,
    price,
    amount,
    ...props
}) => {
    return (
        <div
            className="field has-addons"
            {...props}
            style={{ marginBottom: '-1rem' }}
        >
            <p className="control">
                <input
                    className="input"
                    type="number"
                    placeholder={intl.formatMessage({
                        id: 'exhibitApplication.valuePlaceholder',
                    })}
                    value={value}
                    onChange={onChange}
                />
            </p>
            <p className="control">
                <a className="button is-static">
                    <FormattedMessage id={`exhibitApplication.units.${unit}`} />
                </a>
            </p>
            <p className="control">
                <Value className="input is-static">× €{price}</Value>
            </p>
            <p className="control" style={{ marginLeft: 'auto' }}>
                <Value className="input is-static">€{amount}</Value>
            </p>
        </div>
    );
};

export default injectIntl(ValueField);



// WEBPACK FOOTER //
// ./src/components/ContactForm/components/ValueField.js